import { generateListTags } from 'utils/helpers/fetch';
import dispatchingApi from '../dispatchingApi';

// example mock
/*
queryFn: ({ params }) =>
  import('./mockData/viewTrailerDetailsByLocation').then(({ default: getTrailers }) => ({
    data: getTrailers(params),
  })),
*/

// const getUrl = R.concat('loadsPlan/');

const loadsPlanEndpoints = dispatchingApi.injectEndpoints({
  endpoints: ({ query }) => ({
    viewLoadsPlanSummaryByDriver: query({
      providesTags: generateListTags('Driver', 'driverId'),
      queryFn: () =>
        import('./mockData/viewLoadsPlanSummaryByDriver').then(({ default: getDrivers }) => ({
          data: getDrivers(),
        })),
    }),
  }),
});

// eslint-disable-next-line import/prefer-default-export
export const { useViewLoadsPlanSummaryByDriverQuery } = loadsPlanEndpoints;
